import React, {Component, Fragment} from 'react';

class CreateExpression extends Component {
  handleSelectType(type) {
    const {variables, onChange} = this.props;

    switch(type) {
      case 'LOGIC':
        onChange({'and': [null, null]});
        break;
      case 'COMPARE':
        onChange({'==': [null, null]});
        break;
      case 'DATETIME_COMPARE':
        onChange({'datetime_after': [
          {'var': Object.keys(variables).filter(key => variables[key].type === 'DATETIME')[0]},
          null
        ]});
        break;
      case 'FORMULA':
        onChange({'+': [null, null]});
        break;
      case 'VARIABLE':
        onChange({'var': Object.keys(variables)[0]});
        break;
      case 'VALIDATION':
        onChange({'!': [null]});
        break;
      case 'OPTIONS':
      case 'STATIC_TEXT':
        onChange("");
        break;
      case 'STATIC_NUMBER':
        onChange(0);
        break;
      case 'STATIC_BOOLEAN':
        onChange(true);
        break;
      default:
        throw new Error(`Unknown expression type: ${type}`);
    }
  }

  render() {
    const {variables, options, parentType, expressionTypes} = this.props; //added parent type option

    // When expressionTypes is provided only those expression types can be created, so a builder can be
    // restricted to a subset (e.g. math formulas only). Without it every expression type is offered.
    const isAllowed = type => !expressionTypes || expressionTypes.indexOf(type) >= 0;

    return (
      <select onChange={e => this.handleSelectType(e.target.value)}>
        <option value={null}>{parentType === "Notification" ? "Always":"Choose an expression..."}</option>
        {isAllowed('LOGIC') ? <option value="LOGIC">Logic operation</option> : null}
        {isAllowed('COMPARE') ? <option value="COMPARE">Value comparison</option> : null}
        {isAllowed('VALIDATION') ? <option value="VALIDATION">Validation</option> : null}
        {isAllowed('DATETIME_COMPARE') && variables && Object.keys(variables).filter(key => variables[key].type === 'DATETIME').length > 0 ? (
          <option value="DATETIME_COMPARE">Date/Time comparison</option>
        ) : null}
        {isAllowed('FORMULA') ? <option value="FORMULA">Math formula</option> : null}
        {isAllowed('VARIABLE') && variables && Object.keys(variables).length > 0 ? (
          <option value="VARIABLE">Variable</option>
        ) : null}
        {options && options.length > 0 ? (
          isAllowed('OPTIONS') ? <option value="OPTIONS">Options</option> : null
        ): (
          <Fragment>
            {isAllowed('STATIC_TEXT') ? <option value="STATIC_TEXT">Text</option> : null}
            {isAllowed('STATIC_NUMBER') ? <option value="STATIC_NUMBER">Number</option> : null}
            {isAllowed('STATIC_BOOLEAN') ? <option value="STATIC_BOOLEAN">True or false</option> : null}
          </Fragment>
        )}
      </select>
    )
  }
}

export default CreateExpression;
